import {
  ApiResponse,
  Clinic,
  ClinicUser,
  PaginationResponse,
  User,
} from '@magnetar/admin-api-interfaces'
import { useAuth } from './useAuth'
import { useGet } from './useFetch'

interface UseClinicUsersParams {
  page?: number
  pageSize?: number
  clinic_id?: number
  account?: string
}

export function useClinicUsers({
  page = 1,
  pageSize = 10,
  clinic_id,
  account,
}: UseClinicUsersParams = {}) {
  const { token } = useAuth()

  const params: Record<string, unknown> = {
    page,
    pageSize,
  }

  if (clinic_id) params.clinic_id = clinic_id
  if (account) params.account = account

  const { data, error, mutate } = useGet<
    ApiResponse<PaginationResponse<ClinicUser & { user: User; clinic: Clinic }>>
  >(
    token ? '/api/clinic-users' : null,
    params,
    token ?? '',
    undefined,
    { keepPreviousData: true },
  )

  return {
    clinicUsers: data?.data?.items,
    pagination: data?.data
      ? {
          page: data.data.page,
          pageSize: data.data.pageSize,
          total: data.data.total,
          totalPages: data.data.totalPages,
        }
      : undefined,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
